module.exports = __webpack_public_path__ + "img/삼성동 맛집.782d187c.png";